const navLinkStyledFPC = {
  text: 'Volte para página inicial para entrar'
};

export default navLinkStyledFPC;
